import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';

export const END_OF_PAGE_RECOMMENDATIONS_METRIC = createPageSegmentLoadMetric({
	key: END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY,
});
